import { put, call } from 'redux-saga/effects';
import { Types } from './actions';
import ProceduresRepository from '../../../../repositories/ProceduresRepository';
import ProceduresDataRepository from '../../../../../data/repositories/ProceduresDataRepository';

export default function* saga(action: any): any {
  try {
    const { request } = action;
    yield put({ type: Types.REGISTER_TICKET_REQUEST });
    const procedureRepository: ProceduresRepository =
      new ProceduresDataRepository();
    const procedureResponse = yield call(
      procedureRepository.registerTicketNotAutomated,
      request
    );

    if (!procedureResponse) {
      yield put({
        type: Types.REGISTER_TICKET_FAILURE,
        error: true
      });
      return;
    }
    if (!procedureResponse?.ticketId) {
      yield put({
        type: Types.REGISTER_TICKET_FAILURE,
        error: true
      });
      return;
    }
    yield put({
      type: Types.REGISTER_TICKET_SUCCESS,
      data: procedureResponse
    });
  } catch (error) {
    yield put({
      type: Types.REGISTER_TICKET_FAILURE,
      error: {
        title: 'Ocurrió un problema inesperado',
        subtitle: 'Por favor, vuelve a intentarlo.'
      }
    });
  }
}
